import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_PERMISSIONS_PUSH",
    parentId: "SETTINGS_PERMISSIONS",
    applicationRights: Rights,
    title: 'Push-varsler',
    text: 'Push-varsler',
    canShowOnDashboard: false,
    url: `/settings/permissions/PUSH_NOTIFICATIONS`
})
